import { Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { PATHS_DOC, ROOT_APP } from 'src/routes/paths';

const PREFIX = 'Logo';

const classes = {
  logo: `${PREFIX}-logo`,
};

const Logo = ({ disabledLink = false, ...props }) => {
  const pathname = useLocation().pathname;
  const navigate = useNavigate();

  const isDocs = pathname.includes(PATHS_DOC.ROOT);

  const logo = (
    <Box
      component="img"
      src="/static/logo.png"
      alt="Logo"
      onClick={() => navigate(isDocs ? PATHS_DOC.ROOT : ROOT_APP)}
      className={classes.logo}
      {...props}
    />
  );

  if (disabledLink) {
    return logo;
  }

  return logo;
};

export default Logo;
